import axios from 'axios';
import { BASE_URL } from '../components/Constant';

const authHeaders = () => ({
  // eslint-disable-next-line no-undef
  authorization: `${localStorage.getItem('token')}`
});

const getPurchases = (params = {}) =>
  axios.get(BASE_URL + 'purchases', {
    headers: authHeaders(),
    params
  });

const getPurchaseOptions = () =>
  axios.get(BASE_URL + 'purchases/options', {
    headers: authHeaders()
  });

const getPurchaseFilterOptions = (params = {}) =>
  axios.get(BASE_URL + 'purchases/filter-options', {
    headers: authHeaders(),
    params
  });

const createPurchase = (purchase) =>
  axios.post(BASE_URL + 'purchases', purchase, {
    headers: authHeaders()
  });

const searchBoxshallProducts = (search = '') =>
  axios.get(BASE_URL + 'purchases/options/items', {
    headers: authHeaders(),
    params: { search, limit: 50 }
  });

const updatePurchase = (purchaseId, changes) =>
  axios.patch(BASE_URL + `purchases/${purchaseId}`, changes, {
    headers: authHeaders()
  });

const deletePurchase = (purchaseId) =>
  axios.delete(BASE_URL + `purchases/${purchaseId}`, {
    headers: authHeaders()
  });

const purchaseService = {
  createPurchase,
  deletePurchase,
  getPurchaseFilterOptions,
  getPurchaseOptions,
  getPurchases,
  searchBoxshallProducts,
  updatePurchase
};

export default purchaseService;
